
import React, { useState, useEffect, useRef } from 'react';

import { HiOutlineSearch } from "react-icons/hi";
import { X } from "lucide-react";
import { useTranslation } from "react-i18next";

import { logOut } from "../store/actions/authActions";
import { connect } from "react-redux";
import { compose } from "redux";

import { getProfile } from "../store/actions/profileActions";
import {getRisks} from "../store/actions/riskActions";
import { getControls_Report, getControls_Search, editControl } from "../store/actions/riskActions";
import ControlOverlay from "../components/Control/ControlOverlay";
import RiskDetailsForm from "../components/Risk/RiskOverlay";
import { useHistory, useLocation } from 'react-router-dom'

const SearchBar = ({ profile, getRisksFN, editControlFN, getControlsReportFN, getControlsSearchFN, risks, controls, expandable = false, alignRight = false }) => {
  const { t } = useTranslation();

  const history = useHistory()
  const { pathname } = useLocation()
  const containerRef = useRef(null);
  const inputRef = useRef(null);

  const [flattenedControls, setFlattenedControls] = useState([]);
  const [selectedControl, setSelectedControl] = useState(null);
  const [selectedRiskID, setSelectedRiskID] = useState(null);
  const [open, setOpen] = useState(false)
  const [expanded, setExpanded] = useState(!expandable);
  const [search, setSearch] = useState("");


   const goToRisk = id => {
    // derive domain segment if needed
    const domain = pathname.split('/')[1] || ''
    // push new URL with risk ID param
    history.push(`/risk/${id}`)
  }

   useEffect(() => {
    if (profile?.department_id) {
        //////console.log("Risks Getting", profile.department_id)
        getRisksFN(1, 100, profile.department_id, "None")
    }
    }, [getRisksFN, profile.department_id]);

    useEffect(() => {
    if (profile) {
        //////console.log("Controls Getting", profile.department_id)
        //getControlsReportFN( profile.department_id)
        getControlsSearchFN(profile.department_id)
    }
    }, [getControlsSearchFN, profile.department_id]);
    
    useEffect(() => {
          if (controls && controls?.length > 0) {
              //////console.log("Controls before flat:" , controls);
              const allControls = controls
                  .filter((control) =>
                      control.controls.some(
                          (c) =>
                              c.controlDetails !== null ||
                              c.controlType !== null ||
                              c.controlDefinition !== null
                      )
                      
                  )
                  .flatMap((control) =>
                      control.controls.map((c) => ({
                          ...c,
                          riskId: control.riskId,
                          title: control.title,
                          owner: c.owner,
                      }))
                  );
              setFlattenedControls(allControls);
          } else {
              setFlattenedControls([]);
          }
      }, [controls]);

  useEffect(() => {
    if (expanded) inputRef.current?.focus();
  }, [expanded]);

  useEffect(() => {
    if (!expandable) return undefined;
    const handleClickOutside = (event) => {
      if (!containerRef.current?.contains(event.target) && !search) {
        setExpanded(false);
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [expandable, search]);

  const collapseSearch = () => {
    if (!expandable) return;
    setSearch("");
    setOpen(false);
    setExpanded(false);
  };

  const closeCreation = async (data, control_id, risk_id) => {
    ////console.log("Data:", data, "ID", control_id)

    setSelectedControl(null)
    await updateServerData(data, control_id, risk_id);
    getControlsSearchFN(profile.department_id)

  }

  const updateServerData = async (data, control_id, risk_id) => {


    const updatedData = { ...data };

    // Add one day to StartDate and EndDate if they exist
    if (updatedData.StartDate) {
      const startDate = new Date(updatedData.StartDate);
      startDate.setDate(startDate.getDate() + 1);
      updatedData.StartDate = startDate.toISOString().split('T')[0]; // Format as YYYY-MM-DD
    }

    if (updatedData.EndDate) {
      const endDate = new Date(updatedData.EndDate);
      endDate.setDate(endDate.getDate() + 1);
      updatedData.EndDate = endDate.toISOString().split('T')[0]; // Format as YYYY-MM-DD
    }

    //////console.log("CONTROL DATA AFTER ADJUSTMENT", updatedData);

    await editControlFN(risk_id, control_id, updatedData);


  }
  const filteredA = risks.filter((risk) =>
    risk.Title?.toLowerCase().includes(search.toLowerCase())
  );
  //controls = [controls]
  //////console.log("Controls",flattenedControls)
  const filteredB = flattenedControls.filter((control) =>
    control.controlDetails?.toLowerCase()?.includes(search.toLowerCase())
  );

//   const filteredClasses = Risks2.filter(Risk =>
//   Risk.title.toLowerCase().includes(search.toLowerCase())
//     );

  return (
    <div
      ref={containerRef}
      className={`relative transition-[width,max-width] duration-300 ease-out ${
        expandable && !expanded ? "w-10 flex-shrink-0" : "w-[min(100%,280px)]"
      }`}
    >
      {expandable && !expanded ? (
        <button
          type="button"
          onClick={() => setExpanded(true)}
          className="w-10 h-10 flex items-center justify-center rounded-xl border border-gray-200 bg-gray-50 text-gray-500 hover:bg-gray-100 hover:text-gray-700 transition-all duration-200 active:scale-95"
          aria-label={t("topBar.searchPlaceholder")}
        >
          <HiOutlineSearch size={20} />
        </button>
      ) : (
        <div className="relative animate-search-expand">
          <HiOutlineSearch
            className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none"
            size={18}
          />
          <input
            ref={inputRef}
            type="text"
            placeholder={t("topBar.searchPlaceholder")}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            onFocus={() => setOpen(true)}
            onBlur={() => { if (!search) setOpen(false); }}
            className="w-full h-10 pl-10 pr-9 rounded-xl border border-gray-200 text-gray-900 bg-gray-50 text-sm focus:outline-none focus:ring-2 focus:ring-blue-100 focus:border-blue-300 focus:bg-white transition-colors"
          />
          {expandable && (
            <button
              type="button"
              onClick={collapseSearch}
              className="absolute right-2 top-1/2 -translate-y-1/2 p-1 rounded-md text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition-colors"
              aria-label={t("topBar.closeSearch", { defaultValue: "Close search" })}
            >
              <X size={16} />
            </button>
          )}
        </div>
      )}

      {open && search?.length > 0 && (
        <div className={`absolute top-[calc(100%+6px)] w-full min-w-[280px] max-h-80 overflow-y-auto bg-white border border-gray-200 rounded-xl shadow-lg z-[310] animate-fade-slide-down ${alignRight ? "right-0" : "left-0"}`}>
          {filteredA?.length > 0 && (
            <div>
              <p className="pl-4 py-1 font-semibold text-blue-800">Risks</p>
              {filteredA.map((risk, i) => (
                <div
                  key={risk.ID}
                  onClick={() => {
                    setSelectedRiskID(risk.ID);
                    goToRisk(risk.ID);
                    ////console.log(risk);
                  }}
                  className={`cursor-pointer hover:bg-gray-200 px-4 py-2 ${i < filteredA?.length - 1 ? "border-b border-gray-200" : ""
                    }`}
                >
                  <p
                    className="text-base font-medium"
                    onMouseDown={(e) => e.preventDefault()}
                  >
                    {risk.Title}
                  </p>
                  <div className="flex space-x-1 text-sm text-gray-500">
                    <span>{risk.OwnerFirstName}</span>
                    <span>{risk.OwnerLastName}</span>
                  </div>
                </div>
              ))}
            </div>
          )}

          {filteredB?.length > 0 && (
            <div className="mt-2">
              <p className="pl-4 py-1 font-semibold text-blue-800">Controls</p>
              {filteredB.map((control, i) => (
                <div
                  key={control.controlID}
                  onClick={() => {
                    setSelectedControl(control);
                    ////console.log(control);
                  }}
                  className={`cursor-pointer hover:bg-gray-200 px-4 py-2 ${i < filteredB?.length - 1 ? "border-b border-gray-200" : ""
                    }`}
                  onMouseDown={(e) => e.preventDefault()}
                >
                  {control.controlDetails}
                </div>
              ))}
            </div>
          )}

          {filteredA?.length === 0 && filteredB?.length === 0 && (
            <p className="text-gray-400 italic px-4 py-2">No matches</p>
          )}
        </div>
      )}

      

      {selectedControl && (
        <ControlOverlay
          open={!!selectedControl}
          onClose={() => setSelectedControl(null)}
          key={selectedControl.controlID || 'new-control'}
          closeControl={closeCreation}
          control_id={selectedControl.controlID}
          risk_id={selectedControl.riskId}
        />
      )}

       

    </div>
  );
};


const mapStateToProps = (state) => {
    //////console.log("Entire Redux state:", state);
    //////console.log("Risks", state.risk.risks);
    return {

        
        profile: state.profile.profile,
        risks: state.risk.risks,
        controls: state.risk.all_risk_controls,

    };
};

const mapDispatchToProps = (dispatch) => {
    return {

        logOutFN: () => dispatch(logOut()),
        getProfileFN: () => dispatch(getProfile()),
        getRisksFN: (currentPage, pageSize, department_id, sortBy) => dispatch(getRisks(currentPage, pageSize, department_id, sortBy)),
        getControlsReportFN: (departmentId) => dispatch(getControls_Report(departmentId)),
        getControlsSearchFN: (departmentId) => dispatch(getControls_Search(departmentId)),
        editControlFN: (risk_id, control_id, control) => dispatch(editControl(risk_id, control_id, control)),

    };
};


export default compose(connect(mapStateToProps, mapDispatchToProps))(SearchBar);